<script lang="ts">
  import { NewsPage } from '@pages/news';

  import type { PageData } from './$types';

  export let data: PageData;
</script>

<NewsPage news="{data.news}" totalCount="{data.totalCount}" pageNumber="{data.page}" loadMore="{data.loadMore}" />
